import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import { clx } from "../../../utils/Helpers";
import UIAvatar from "../UIAvatar";
import "./UIUserInfo.scss";

const UIUserInfo = ({
  name,
  description,
  descriptionPlacement,
  image,
  initials,
  maxInitials,
  children,
  className,
  classNames,
}) => (
  <Box className={clx("ui-user-info", className, classNames.root)}>
    <UIAvatar
      src={image}
      className={clx("ui-user-info__avatar", classNames.avatar)}
      initials={initials}
      maxInitials={maxInitials}
      name={typeof name === "string" ? name : ""}
      size="md"
    />
    <Box
      className={clx(
        "ui-user-info__copy",
        descriptionPlacement === "top" && "ui-user-info__copy--description-top",
        classNames.copy
      )}
    >
      <Typography className={clx("ui-user-info__name", classNames.name)}>
        {name}
      </Typography>
      {description ? (
        <Typography
          className={clx("ui-user-info__description", classNames.description)}
        >
          {description}
        </Typography>
      ) : null}
      {children}
    </Box>
  </Box>
);

UIUserInfo.propTypes = {
  name: PropTypes.node.isRequired,
  description: PropTypes.node,
  descriptionPlacement: PropTypes.oneOf(["bottom", "top"]),
  image: PropTypes.string,
  initials: PropTypes.string,
  maxInitials: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  classNames: PropTypes.shape({
    root: PropTypes.string,
    avatar: PropTypes.string,
    copy: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
};

UIUserInfo.defaultProps = {
  description: null,
  descriptionPlacement: "bottom",
  image: undefined,
  initials: "",
  maxInitials: 2,
  children: null,
  className: "",
  classNames: {},
};

export default UIUserInfo;
